import script from "./EditUser.vue?vue&type=script&setup=true&lang=js"
export * from "./EditUser.vue?vue&type=script&setup=true&lang=js"

import "./EditUser.vue?vue&type=style&index=0&id=b858eff4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b858eff4"]])

export default __exports__